import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { ARLogger } from '@relayter/core';
import { NucButtonDestructiveComponent, NucButtonSecondaryComponent, NucFormFieldComponent, NucInputComponent } from '@relayter/rubber-duck';
import { TeamService } from '../../api/services/team.service';
import { TeamModel, TeamPatchModel } from '../../models/response/team.model';

interface IDisabledTeamForm {
    teamName: FormControl<string>;
}
@Component({
    selector: 'om-disable-team-form',
    templateUrl: './disable-team-form.component.html',
    styleUrls: ['./disable-team-form.component.scss'],
    imports: [NucInputComponent, ReactiveFormsModule, NucFormFieldComponent, NucButtonSecondaryComponent, NucButtonDestructiveComponent]
})
export class DisableTeamFormComponent implements OnInit {
    private readonly fbs = inject(UntypedFormBuilder);
    private readonly teamService = inject(TeamService);

    public disableTeamForm: FormGroup<IDisabledTeamForm>;
    public isLoading = false;

    @Input()
    public team: TeamModel;

    @Output()
    public formSubmittedSuccess: EventEmitter<void> = new EventEmitter<void>();

    @Output()
    public formCanceled: EventEmitter<void> = new EventEmitter<void>();

    public ngOnInit(): void {
        const productFormData = {
            teamName: ['']
        };
        this.disableTeamForm = this.fbs.group(productFormData);
    }

    /**
     * Do api call to patch the disabled property on a team
     */
    public onSubmit(): void {
        this.isLoading = true;
        this.teamService.patchTeam(this.team._id, new TeamPatchModel(true)).subscribe({
            next: (updatedTeam: TeamModel) => {
                this.isLoading = false;
                ARLogger.info(`Team ${updatedTeam.name} successfully disabled`);
                this.formSubmittedSuccess.emit();
            },
            error: (error: any) => {
                this.isLoading = false;
                alert('disabling team went wrong, Error: ' + error.message);
            }
        });
    }

    /**
     * User pressed cancel in the confirm disable team form
     */
    public onCancel(): void {
        this.formCanceled.emit();
    }
}
